"use client";

import { StatusDot, StatusType } from "./StatusDot";

interface ConnectionStatusBadgeProps {
  status: StatusType;
  showLabel?: boolean;
  className?: string;
}

const statusLabels: Record<StatusType, string> = {
  connected: "동기화됨",
  syncing: "동기화 중...",
  reconnecting: "재연결 중...",
  disconnected: "연결 끊김",
  editing: "편집 중",
};

export function ConnectionStatusBadge({
  status,
  showLabel = true,
  className = "",
}: ConnectionStatusBadgeProps) {
  const isPulsing = status === "syncing" || status === "reconnecting";

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <StatusDot status={status} pulse={isPulsing} />
      {showLabel && (
        <span className="text-xs text-neutral-500">{statusLabels[status]}</span>
      )}
    </div>
  );
}

export { type ConnectionStatusBadgeProps };
